export const LinkTypes = {
  PAGE: 'page',
  EMAIL: 'email',
  URL: 'url',
  FILE: 'file',
  EMAIL_SUBSCRIPTION: 'email_subscription',
  VIEW_AS_WEBPAGE: 'view_as_page_url',
  MEETING: 'meeting',
  ANCHOR: 'anchor',
  NONE: 'no_link'
};
export const ExternalLinkTypes = [LinkTypes.FILE, LinkTypes.MEETING];
export const ReadOnlyLinkTypes = [LinkTypes.ANCHOR, LinkTypes.EMAIL, LinkTypes.FILE];
export let EmailSubscriptionHublVariables;
(function (EmailSubscriptionHublVariables) {
  EmailSubscriptionHublVariables["UNSUBSCRIBE"] = "unsubscribe_link";
  EmailSubscriptionHublVariables["SUBSCRIPTION_CONFIRMATION"] = "subscription_confirmation_url";
  EmailSubscriptionHublVariables["UNSUBSCRIBE_ALL"] = "unsubscribe_link_all";
  EmailSubscriptionHublVariables["VIEW_AS_WEBPAGE"] = "view_as_page_url";
  EmailSubscriptionHublVariables["MEMBERSHIP_REGISTRATION_LINK"] = "membership_registration_link";
  EmailSubscriptionHublVariables["MEMBERSHIP_PASSWORD_SAVED_LINK"] = "membership_password_saved_link";
  EmailSubscriptionHublVariables["MEMBERSHIP_PASSWORD_RESET_LINK"] = "membership_password_reset_link";
})(EmailSubscriptionHublVariables || (EmailSubscriptionHublVariables = {}));
export const EMAIL_SUBSCRIPTION_MEMBERSHIP_LINKS = [EmailSubscriptionHublVariables.MEMBERSHIP_REGISTRATION_LINK, EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_SAVED_LINK, EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_RESET_LINK];
export const EMAIL_SUBSCRIPTION_NON_MEMBERSHIP_LINKS = [EmailSubscriptionHublVariables.UNSUBSCRIBE, EmailSubscriptionHublVariables.SUBSCRIPTION_CONFIRMATION, EmailSubscriptionHublVariables.UNSUBSCRIBE_ALL,
/**
 * @TODO Remove this option once `allowEmailWebVersionLink` is fully ungated
 */
EmailSubscriptionHublVariables.VIEW_AS_WEBPAGE];
export const i18nKey = suffix => `RichTextLib.links.${suffix}`;
export const CacheableLinkTypes = [LinkTypes.PAGE, LinkTypes.FILE, LinkTypes.MEETING];
export const CacheableLinkFields = ['linkDisplayName', 'linkType', 'fileMeta'];
export const TrackableLinkFields = ['externalLink', 'linkType', 'isValidLink', 'relAttr'];
export const LinkRelDefault = 'noopener';
export let LinkRelTypes;
(function (LinkRelTypes) {
  LinkRelTypes["REGULAR"] = "regular";
  LinkRelTypes["NOFOLLOW"] = "nofollow";
  LinkRelTypes["SPONSORED"] = "sponsored";
  LinkRelTypes["UGC"] = "ugc";
})(LinkRelTypes || (LinkRelTypes = {}));
export const EmailSubscriptionLinkOptions = {
  [EmailSubscriptionHublVariables.UNSUBSCRIBE]: {
    text: 'emailSystemLinks.unsubscribe',
    help: 'emailSystemLinks.unsubscribeHelpText',
    value: EmailSubscriptionHublVariables.UNSUBSCRIBE
  },
  [EmailSubscriptionHublVariables.SUBSCRIPTION_CONFIRMATION]: {
    text: 'emailSystemLinks.subscriptionConfirmation',
    help: 'emailSystemLinks.subscriptionConfirmationHelpText',
    value: EmailSubscriptionHublVariables.SUBSCRIPTION_CONFIRMATION
  },
  [EmailSubscriptionHublVariables.MEMBERSHIP_REGISTRATION_LINK]: {
    text: 'emailSystemLinks.membershipRegistration',
    help: 'emailSystemLinks.membershipRegistrationHelpText',
    value: EmailSubscriptionHublVariables.MEMBERSHIP_REGISTRATION_LINK
  },
  [EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_SAVED_LINK]: {
    text: 'emailSystemLinks.membershipPasswordSaved',
    help: 'emailSystemLinks.membershipPasswordSavedHelpText',
    value: EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_SAVED_LINK
  },
  [EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_RESET_LINK]: {
    text: 'emailSystemLinks.membershipPasswordReset',
    help: 'emailSystemLinks.membershipPasswordResetHelpText',
    value: EmailSubscriptionHublVariables.MEMBERSHIP_PASSWORD_RESET_LINK
  },
  [EmailSubscriptionHublVariables.UNSUBSCRIBE_ALL]: {
    text: 'emailSystemLinks.unsubscribeAll',
    help: 'emailSystemLinks.unsubscribeAllHelpText',
    value: EmailSubscriptionHublVariables.UNSUBSCRIBE_ALL
  },
  /**
   * @TODO Remove this option once `allowEmailWebVersionLink` is fully ungated
   */
  [EmailSubscriptionHublVariables.VIEW_AS_WEBPAGE]: {
    text: 'emailSystemLinks.viewAsWebpage',
    help: 'emailSystemLinks.viewAsWebpageHelpText',
    value: EmailSubscriptionHublVariables.VIEW_AS_WEBPAGE
  }
};
export const ExtraHublVariablesLinkOptions = {
  [LinkTypes.VIEW_AS_WEBPAGE]: {
    text: 'emailSystemLinks.webVersionUrl',
    value: LinkTypes.VIEW_AS_WEBPAGE
  }
};